import React, { useMemo, useState } from "react";
import { useThemeStore } from "@shared/stores/themeStore";

type Props = {
  src: string;
  srcHover?: string;
  srcDark?: string;
  srcDarkHover?: string;
  alt: string;
  className?: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

const Icon = ({ src, srcHover, srcDark, srcDarkHover, alt, className, ...props }: Props) => {
  const { isDarkMode } = useThemeStore();
  const [isHovered, setIsHovered] = useState(false);

  const icon = useMemo(() => {
    if (isDarkMode) {
      return isHovered ? srcDarkHover || srcDark || src : srcDark || src;
    } else {
      return isHovered ? srcHover || src : src;
    }
  }, [isDarkMode, isHovered, src, srcHover, srcDark, srcDarkHover]);

  return (
    <img
      src={icon}
      alt={alt}
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    />
  );
};

export default Icon;
